import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { axiosInstance, BASE_URL } from "../../Config";
import "@fancyapps/fancybox/dist/jquery.fancybox.css";
import "@fancyapps/fancybox";

const MatchList = () => {
    const navigate = useNavigate();

    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedMatch, setSelectedMatch] = useState(null);
    const [matches, setMatches] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [loading, setLoading] = useState(true);
    const limit = 10;
    const [dateFilter, setDateFilter] = useState("all");

    const dateFilters = [
        { value: "all", label: "All Data" },
        { value: "7", label: "Last 7 Days" },
        { value: "30", label: "This Month" },
        { value: "180", label: "Last 6 Months" },
        { value: "365", label: "Last Year" },
    ];

    useEffect(() => {
        fetchMatches(currentPage, searchTerm, dateFilter);
    }, [currentPage, searchTerm, dateFilter]);

    const fetchMatches = async (page, search = "", filter = "all") => {
        setLoading(true);
        try {
            const response = await axiosInstance.get(
                `/matchList?page=${page}&limit=${limit}&search=${encodeURIComponent(
                    search,
                )}&dateFilter=${filter}`
            );
            if (response.data.success) {
                setMatches(response.data.body.data || []);
                setTotalPages(response.data.body.totalPages || 1);
            } else {
                setMatches([]);
                setTotalPages(0);
            }
        } catch (error) {
            console.error("Error fetching matches:", error);
            setMatches([]);
            setTotalPages(0);
        } finally {
            setLoading(false);
        }
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
    };

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    const handleDateFilter = (value) => {
        setDateFilter(value);
        setCurrentPage(1);
    };

    const deleteMatchHandler = async (id) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "green",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        });

        if (result.isConfirmed) {
            try {
                setLoading(true);
                await axiosInstance.delete(`/matchDelete/${id}`);

                const response = await axiosInstance.get(
                    `/matchList?page=${currentPage}&limit=${limit}&search=${encodeURIComponent(
                        searchTerm,
                    )}&dateFilter=${dateFilter}`
                );

                if (response.data.success) {
                    const newTotalPages = response.data.body.totalPages;
                    const newData = response.data.body.data;

                    if (newData.length === 0 && currentPage > 1) {
                        setCurrentPage((prevPage) => prevPage - 1);
                    } else {
                        setMatches(newData);
                        setTotalPages(newTotalPages);
                    }
                }
            } catch (error) {
                Swal.fire(
                    "Error!",
                    error.response?.data?.message || "Error deleting match",
                    "error"
                );
            } finally {
                setLoading(false);
            }
        }
    };

    const handleViewDetails = (match) => {
        setSelectedMatch(match);
    };

    const getCurrentFilterLabel = () => {
        const filter = dateFilters.find((f) => f.value === dateFilter);
        return filter ? filter.label : "All Data";
    };

    const getSerialNumber = (index) => {
        return (currentPage - 1) * limit + index + 1;
    };

    const getProductImage = (match) => {
        if (match.matchedProduct && match.matchedProduct.image) {
            return match.matchedProduct.image;
        }
        return null;
    };
    return (
        <>
            <div id="layout-wrapper">
                <div className="main-content">
                    <div className="page-content">
                        <div className="container-fluid">
                            <div className="title-box mb-3 pb-1 d-flex justify-content-between align-items-center">
                                <h4 className="mb-0 page-title">Match List</h4>
                            </div>
                            <div>
                                <nav aria-label="breadcrumb" className="mt-1">
                                    <ol className="breadcrumb mb-0">
                                        <li className="breadcrumb-item">
                                            <Link to="/dashboard" className="new">
                                                <i className="ri-home-4-fill me-1 new" /> Home
                                            </Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to="/" className="new">
                                                <i className="ri-group-2-line me-1 new" /> Matches
                                            </Link>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            Match Listings
                                        </li>
                                    </ol>
                                </nav>
                            </div>

                            <div className="card">
                                <div className="card-body cusbar">
                                    <div
                                        className="card-head justify-content-start adjusttwo mb-3"
                                        style={{ flexWrap: "nowrap" }}
                                    >
                                        <div className="tbl-search position-relative">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Search by buyer, seller, or product..."
                                                value={searchTerm}
                                                onChange={handleSearchChange}
                                            />
                                            <i className="ri-search-line" />
                                        </div>

                                        <div className="dropdown tbl-drop mb-3">
                                            <button
                                                className="btn btn-light dropdown-toggle"
                                                type="button"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                            >
                                                {getCurrentFilterLabel()}
                                            </button>
                                            <ul className="dropdown-menu">
                                                {dateFilters.map((filter) => (
                                                    <li key={filter.value}>
                                                        <button
                                                            className="dropdown-item"
                                                            type="button"
                                                            onClick={() => handleDateFilter(filter.value)}
                                                        >
                                                            {filter.label}
                                                        </button>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>

                                    {loading ? (
                                        <div className="text-center py-5">
                                            <div
                                                className="spinner-border text-primary"
                                                role="status"
                                            >
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="table-responsive table-card border-top">
                                            <div data-simplebar="" className="cus-scroll scmob">
                                                <table className="table table-centered cus-nowrap align-middle hltr mb-0">
                                                    <thead>
                                                        <tr>
                                                            <th>Sr no.</th>
                                                            <th>Product</th>
                                                            <th>Buyer</th>
                                                            <th>Seller</th>
                                                            <th className="text-end">Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {matches.length > 0 ? (
                                                            matches.map((match, index) => (
                                                                <tr key={match.id}>
                                                                    <td>{getSerialNumber(index)}</td>
                                                                    <td>
                                                                        {match && match.matchedProduct ? (
                                                                            <>{match.matchedProduct.brandName || ""} {match.matchedProduct.model || ""}</>
                                                                        ) : (
                                                                            ""
                                                                        )}                                                                    </td>
                                                                    <td>
                                                                        <div>
                                                                            <div className="fw-semibold">
                                                                                {match.buyer?.name || "N/A"}
                                                                            </div>
                                                                            <small className="text-muted">
                                                                                {match.buyer?.email || "N/A"}
                                                                            </small>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div>
                                                                            <div className="fw-semibold">
                                                                                {match.seller?.name || "N/A"}
                                                                            </div>
                                                                            <small className="text-muted">
                                                                                {match.seller?.email || "N/A"}
                                                                            </small>
                                                                        </div>
                                                                    </td>

                                                                    <td>
                                                                        <div className="d-flex justify-content-end">
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-soft-primary px-2 btn-sm me-1"
                                                                                data-bs-toggle="offcanvas"
                                                                                data-bs-target="#view-details"
                                                                                aria-controls="offcanvasRight"
                                                                                onClick={() =>
                                                                                    handleViewDetails(match)
                                                                                }
                                                                                title="View Details"
                                                                            >
                                                                                <i className="ri-eye-fill font-size-16"></i>
                                                                            </button>

                                                                            <button
                                                                                onClick={() =>
                                                                                    deleteMatchHandler(match.id)
                                                                                }
                                                                                className="btn btn-soft-danger px-2 btn-sm"
                                                                                style={{
                                                                                    backgroundColor: "#ea5455",
                                                                                    borderColor: "#ea5455",
                                                                                    color: "#fff",
                                                                                }}
                                                                                title="Delete Match"
                                                                            >
                                                                                <i className="ri-delete-bin-line font-size-16"></i>
                                                                            </button>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="7" className="text-center py-2">
                                                                    <p className="text-muted">No matches found</p>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>

                                                {totalPages > 1 && (
                                                    <div className="d-flex justify-content-center align-items-center mt-3">
                                                        <Stack spacing={2}>
                                                            <Pagination
                                                                count={totalPages}
                                                                page={currentPage}
                                                                onChange={handlePageChange}
                                                                color="error"
                                                                showFirstButton
                                                                showLastButton
                                                            />
                                                        </Stack>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Offcanvas for Match Details */}
            <div
                className="offcanvas offcanvas-end rdetails"
                tabIndex="-1"
                id="view-details"
                aria-labelledby="offcanvasRightLabel"
            >
                <div className="offcanvas-header d-block">
                    <div className="d-flex align-items-center justify-content-between">
                        <h5 className="offcanvas-title mb-0 fw-semibold">Match Details</h5>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="offcanvas"
                            aria-label="Close"
                        ></button>
                    </div>
                </div>
                <div className="offcanvas-body">
                    {selectedMatch ? (
                        <>
                            <div className="mb-4">
                                <h6 className="fw-semibold mb-3">
                                    <i className="ri-shopping-cart-line me-2"></i>Product Request Details
                                </h6>
                                <div className="row g-3">
                                    <div className="scroll-room mb-3" id="scrollRoom">

                                        {selectedMatch.image ? (
                                            <a
                                                href={`${BASE_URL}/${selectedMatch.image}`}
                                                data-fancybox="gallery"
                                                className="image-popup-gallery-item"
                                            >
                                                <img
                                                    src={`${BASE_URL}/${selectedMatch.image}`}
                                                    className="img-fluid rounded"
                                                    alt="Provider"
                                                    style={{
                                                        width: "100%",
                                                        maxHeight: "300px",
                                                        objectFit: "cover",
                                                    }}
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.src = "https://via.placeholder.com/300x300";
                                                    }}
                                                />
                                            </a>
                                        ) : (
                                            <div
                                                className="bg-light rounded d-flex align-items-center justify-content-center"
                                                style={{ height: "200px" }}
                                            >
                                                <i className="ri-user-line font-size-48 text-muted"></i>
                                            </div>
                                        )}
                                    </div>
                                    <div className="col-6">
                                        <label className="text-muted small">Brand Name</label>
                                        <p className="fw-medium">{selectedMatch.brandName || "N/A"}</p>
                                    </div>
                                    <div className="col-6">
                                        <label className="text-muted small">Model</label>
                                        <p className="fw-medium">{selectedMatch.model || "N/A"}</p>
                                    </div>
                                    <div className="col-6">
                                        <label className="text-muted small">Size</label>
                                        <p className="fw-medium">{selectedMatch.size || "N/A"}</p>
                                    </div>
                                    <div className="col-6">
                                        <label className="text-muted small">Color</label>
                                        <p className="fw-medium">{selectedMatch.color || "N/A"}</p>
                                    </div>
                                    <div className="col-6">
                                        <label className="text-muted small">Type</label>
                                        <p className="fw-medium">{selectedMatch.type || "N/A"}</p>
                                    </div>
                                    <div className="col-6">
                                        <label className="text-muted small">Number of Units Needed</label>
                                        <p className="fw-medium">{selectedMatch.numberOfUnitsNeeded || "N/A"}</p>
                                    </div>
                                    <div className="col-6">
                                        <label className="text-muted small">Currency</label>
                                        <p className="fw-medium">{selectedMatch.currency || "N/A"}</p>
                                    </div>
                                    <div className="col-6">
                                        <label className="text-muted small">Country</label>
                                        <p className="fw-medium">{selectedMatch.country || "N/A"}</p>
                                    </div>
                                    <div className="col-12">
                                        <label className="text-muted small">Other Information</label>
                                        <p className="fw-medium">{selectedMatch.otherinfo || "N/A"}</p>
                                    </div>
                                    <div className="col-6">
                                        <label className="text-muted small">State</label>
                                        <p className="fw-medium">{selectedMatch.state || "N/A"}</p>
                                    </div>
                                    <div className="col-6">
                                        <label className="text-muted small">City</label>
                                        <p className="fw-medium">{selectedMatch.city || "N/A"}</p>
                                    </div>
                                    <div className="col-12">
                                        <label className="text-muted small">Request Delivery Date</label>
                                        <p className="fw-medium">
                                            {selectedMatch.requestDeliveryDate
                                                ? new Date(selectedMatch.requestDeliveryDate).toLocaleDateString()
                                                : "N/A"}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* Product Details */}
                            {selectedMatch.matchedProduct && (
                                <div className="mb-4">
                                    <h6 className="fw-semibold mb-3">Product Information</h6>
                                    <div className="row g-3">
                                        <div className="scroll-room mb-3" id="scrollRoom">
                                            {getProductImage(selectedMatch) ? (
                                                <a
                                                    href={`${BASE_URL}/${getProductImage(selectedMatch)}`}
                                                    data-fancybox="gallery"
                                                    className="image-popup-gallery-item"
                                                >
                                                    <img
                                                        src={`${BASE_URL}/${getProductImage(selectedMatch)}`}
                                                        className="img-fluid rounded"
                                                        alt="Product"
                                                        style={{
                                                            width: "100%",
                                                            maxHeight: "300px",
                                                            objectFit: "cover",
                                                        }}
                                                        onError={(e) => {
                                                            e.target.onerror = null;
                                                            e.target.src = "https://via.placeholder.com/300x300";
                                                        }}
                                                    />
                                                </a>
                                            ) : (
                                                <div
                                                    className="bg-light rounded d-flex align-items-center justify-content-center"
                                                    style={{ height: "200px" }}
                                                >
                                                    <i className="ri-image-line font-size-48 text-muted"></i>
                                                </div>
                                            )}
                                        </div>
                                        <div className="col-6">
                                            <label className="text-muted small">Brand</label>
                                            <p className="fw-medium">{selectedMatch.matchedProduct.brandName || "N/A"}</p>
                                        </div>
                                        <div className="col-6">
                                            <label className="text-muted small">Model</label>
                                            <p className="fw-medium">{selectedMatch.matchedProduct.model || "N/A"}</p>
                                        </div>
                                        <div className="col-6">
                                            <label className="text-muted small">Size</label>
                                            <p className="fw-medium">{selectedMatch.matchedProduct.size || "N/A"}</p>
                                        </div>
                                        <div className="col-6">
                                            <label className="text-muted small">Color</label>
                                            <p className="fw-medium">{selectedMatch.matchedProduct.color || "N/A"}</p>
                                        </div>
                                        <div className="col-6">
                                            <label className="text-muted small">Country</label>
                                            <p className="fw-medium">{selectedMatch.matchedProduct.originCountry || "N/A"}</p>
                                        </div>
                                        <div className="col-6">
                                            <label className="text-muted small">Type</label>
                                            <p className="fw-medium">{selectedMatch.matchedProduct.type || "N/A"}</p>
                                        </div>
                                        <div className="col-6">
                                            <label className="text-muted small">Other Info</label>
                                            <p className="fw-medium">{selectedMatch.matchedProduct.otherinfo || "N/A"}</p>
                                        </div>
                                        <div className="col-6">
                                            <label className="text-muted small">Available Units (Initial)</label>
                                            <p className="fw-medium">{selectedMatch.matchedProduct.numberOfUnitsAvailableInitial || "N/A"}</p>
                                        </div>
                                        <div className="col-6">
                                            <label className="text-muted small">Available Units (Sub Request)</label>
                                            <p className="fw-medium">{selectedMatch.matchedProduct.numberOfUnitsAvailableSubRequest || "N/A"}</p>
                                        </div>
                                        <div className="col-6">
                                            <label className="text-muted small">Minimum Units Required</label>
                                            <p className="fw-medium">{selectedMatch.matchedProduct.minimumUnitsRequiredForPurchase || "N/A"}</p>
                                        </div>
                                        <div className="col-6">
                                            <label className="text-muted small">Unit Price</label>
                                            <p className="fw-medium">{selectedMatch.matchedProduct.unitPrice || "N/A"}</p>
                                        </div>
                                        <div className="col-6">
                                            <label className="text-muted small">Currency</label>
                                            <p className="fw-medium">{selectedMatch.matchedProduct.currency || "N/A"}</p>
                                        </div>
                                        <div className="col-6">
                                            <label className="text-muted small">Shipping Terms</label>
                                            <p className="fw-medium">{selectedMatch.matchedProduct.shippingTerms || "N/A"}</p>
                                        </div>
                                        <div className="col-6">
                                            <label className="text-muted small">Payment Terms</label>
                                            <p className="fw-medium">{selectedMatch.matchedProduct.paymentTerms || "N/A"}</p>
                                        </div>
                                        <div className="col-6">
                                            <label className="text-muted small">Price Guaranteed Till</label>
                                            <p className="fw-medium">{selectedMatch.matchedProduct.priceGuaranteedTill || "N/A"}</p>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Buyer Information */}
                            <div className="mb-4">
                                <h6 className="fw-semibold mb-3">
                                    <i className="ri-user-line me-2"></i>Buyer Information
                                </h6>
                                <div className="row g-3">
                                    <div className="col-12">
                                        <label className="text-muted small">Name</label>
                                        <p className="fw-medium">{selectedMatch.buyer?.name || "N/A"}</p>
                                    </div>
                                    <div className="col-12">
                                        <label className="text-muted small">Email</label>
                                        <p className="fw-medium">{selectedMatch.buyer?.email || "N/A"}</p>
                                    </div>
                                    {selectedMatch.buyer?.phone && (
                                        <div className="col-12">
                                            <label className="text-muted small">Phone</label>
                                            <p className="fw-medium">{selectedMatch.buyer.phone}</p>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Seller Information */}
                            <div className="mb-4">
                                <h6 className="fw-semibold mb-3">
                                    <i className="ri-store-line me-2"></i>Seller Information
                                </h6>
                                <div className="row g-3">
                                    <div className="col-12">
                                        <label className="text-muted small">Name</label>
                                        <p className="fw-medium">{selectedMatch.seller?.name || "N/A"}</p>
                                    </div>
                                    <div className="col-12">
                                        <label className="text-muted small">Email</label>
                                        <p className="fw-medium">{selectedMatch.seller?.email || "N/A"}</p>
                                    </div>
                                    {selectedMatch.seller?.phone && (
                                        <div className="col-12">
                                            <label className="text-muted small">Phone</label>
                                            <p className="fw-medium">{selectedMatch.seller.phone}</p>
                                        </div>
                                    )}
                                </div>
                            </div>


                        </>
                    ) : (
                        <div className="text-center py-5">
                            <i className="ri-user-line font-size-48 text-muted"></i>
                            <p className="mt-3 text-muted">No match selected</p>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default MatchList;